import { bindable } from "aurelia";

export class ChipComponent {
  @bindable private labelText: string;
  @bindable canClose: boolean = false;
  @bindable chipStyle: 'primary' | 'secondary' | 'tertiary' | 'danger' = "primary";
  @bindable chipType: 'solid' | 'soft' | 'outlined' = "solid";
  @bindable chipSize: 'lg' | 'md' = "lg";
  @bindable closeFunction: () => void;
}